<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  configurations.id
                    ? "Editar Configurações de Reserva"
                    : "Cadastrar Configurações de Reserva"
                }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="limit_reservation">
                          <span class="required">*</span> Limite de reserva por
                          usúario:
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.limit_reservation"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="time_cancel">
                          <span class="required">*</span> Tempo limite para
                          cancelamento automático da reserva(Em minutos):
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.time_cancel"
                        />
                      </div>
                      <div class="alert alert-primary col-md-10" role="alert">
                        Exemplo: 60 = 1 hora, 120 = 2 horas.
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> Deseja exibir o ícone?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch1"
                          v-model="configurations.select_chair"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch1"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo exibirá o icone
                        <i class="fas fa-chair"></i>, se inativo exibirá apenas
                        o nome da posiçao!
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> Deseja forçar o filtro
                        de posições?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch2"
                          v-model="configurations.force_filter"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch2"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo o sistema forçará o usuário a filtrar as
                        posições de trabalho com base em seus adicionais no APP.
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="limit_reservation"
                          ><span class="required">*</span> Empresa:
                        </label>
                        <v-select
                          :options="companies"
                          label="company_name"
                          :reduce="(companies) => companies.id"
                          class="style-chooser"
                          v-model="configurations.company_id"
                        >
                          <div slot="no-options">Carregando...</div>
                        </v-select>
                      </div>
                    </div>

                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/configurations" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      configurations: {
        limit_reservation: "",
        time_cancel: "",
        select_chair: "",
        force_filter: "",
        company_id: "",
      },
      companies: [],
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("limit_reservation", self.configurations.limit_reservation);
      fd.append("time_cancel", self.configurations.time_cancel);
      fd.append("select_chair", self.configurations.select_chair);
      fd.append("force_filter", self.configurations.force_filter);
      fd.append("company_id", self.configurations.company_id);

      if (self.configurations.id) {
        fd.append("id", self.configurations.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "configurations";

      let fd = self.makeFormData();

      if (self.configurations.id) {
        api += "/" + self.configurations.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/configurations");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getConfigurations: function (id) {
      const self = this;
      const api = self.$store.state.api + "configurations/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.configurations = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    self.getCompanies();
    if (id) {
      self.getConfigurations(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Configurations/Add.vue